"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const _1 = __importDefault(require("."));
const getPaymentStore = (store) => store.payment;
const getSubscriptions = (store) => {
    const { subscriptions } = getPaymentStore(store);
    return subscriptions.map((item) => ({
        value: item.id,
        label: `$${item.unit_amount / 100} / ${item.product_data.name}`,
        description: item.product_data.description
    }));
};
const getSubscription = (store, productID) => {
    const { subscriptions } = getPaymentStore(store);
    return subscriptions.find(item => item.id === productID);
};
const getPaymentPortalSession = (store) => {
    const { paymentPortalSession } = getPaymentStore(store);
    return paymentPortalSession;
};
const getPaymentPortalSessionError = (store) => {
    const { paymentPortalSessionError } = getPaymentStore(store);
    return paymentPortalSessionError;
};
const getSubscriptionFromUser = (store) => {
    const { subscriptions } = getPaymentStore(store);
    const account = _1.default.user.getUser(store);
    return subscriptions.find(item => item.id === account.productID);
};
exports.default = {
    getPaymentPortalSessionError,
    getPaymentPortalSession,
    getSubscriptions,
    getSubscription,
    getSubscriptionFromUser
};
